export const countryCodeConstants = {
  china: "cn",
  chinaLocalesCode: "zh-cn",
  romania: "ro",
  brazil: "br",
  italy: "it",
  ireland: "ie",
  unitedKingdom: "gb",
};

export const displayFormat = {
  decimalTwoDigits: "{0:n2}",
  decimalFourDigits: "{0:n4}",
};

export const publicKeyword = {
  publicPathName: "public",
};

export const cityTypes = {
  country: 1,
  county: 2,
  city: 3,
};

export const legalFormCodes = {
  partnership: "PTN",
  soleTrader: "ST",
};

export const leasingFactorTypeCodes = {
  leasingFactorWithDP: "LFWDP",
};
